import { render, staticRenderFns } from "./QuickSubHeader.vue?vue&type=template&id=181a54e0&"
import script from "./QuickSubHeader.vue?vue&type=script&lang=ts&"
export * from "./QuickSubHeader.vue?vue&type=script&lang=ts&"
import style0 from "./QuickSubHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports